import instance from './DefaultApi';

export default class DispatchService {
    ControllerName = 'Dispatch';

    // PLC Communication Methods
    ConnectToPLC(plcAddress) {
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/CheckConnection`, plcAddress).then(res => res)
    }

    StartConveyor(plcAddress) {
        const startCommand = {
            ...plcAddress,
            RegisterNumber: 5,
            Signal: 0
        };
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, startCommand).then(res => res)
    }

    Stop(plcAddress) {
        const startCommand = {
            ...plcAddress,
            RegisterNumber: 7,
            Signal: 0
        };
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, startCommand).then(res => res)
    }

    StopTimer(plcAddress) {
        const startCommand = {
            ...plcAddress,
            RegisterNumber: 6,
            Signal: 1
        };
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, startCommand).then(res => res)
    }

    Start(plcAddress) {
        const startCommand = {
            ...plcAddress,
            RegisterNumber: 7,
            Signal: 1
        };
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, startCommand).then(res => res)
    }

    StopConveyor(plcAddress) {
        const stopCommand = {
            ...plcAddress,
            RegisterNumber: 5,
            Signal: 1
        };
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, stopCommand).then(res => res)
    }

    ProgramTCP(plcAddress) {
        return instance.post(`${process.env.REACT_APP_API_URL}PLC/ProgramTCP`, plcAddress).then(res => res)
    }

    // Save Dispatch 
    Save(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/saveWeb`, formData).then(res => res)
    }

    SaveDepot(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SaveWebDepot`, formData).then(res => res)
    }

    // Save Dispatch Carton Receive 
    DispatchCartonReceive(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DispatchCartonReceive`, formData).then(res => res)
    }

    // Save Dispatch Receive 
    SaveDispatchReceive(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SaveDispatchReceive`, formData).then(res => res)
    }

    // Get Dispatch Receive Carton
    GetDispatchReceiveCarton(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReceiveCarton`, formData).then(res => res)
    }

    // get Dispatch Receive
    GetDispatchReceive(tbl) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReceive`, tbl).then(res => res)
    }

    // get Dispatch 
    GetDispatch(tbl) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatch`, tbl).then(res => res)
    }

    RemoveDataFromTempScannedRecords(id) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/RemoveDataFromTempScannedRecords?id=` + id).then(res => res)
    }

    GetDispatchReceived(tbl) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReceived`, tbl).then(res => res)
    }

    GetDispatchReturnCarton(formData) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReturnCarton`, formData).then(res => res)
    }

    UpdateBatchNo(formData) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/UpdateBatchNo`, formData).then(res => res)
    }

    GetTertiaryPackingScan(d) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetTertiaryPackingScan?sid=${d}`).then(res => res)
    }

    // replaced GetTertiaryPackingScan(d) with on scanning items for delivery no.
    GetDeliveryNoItemScan(deliveryNo, uid, createdby) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DealerDispatchScan?deliveryNo=${deliveryNo}&uid=${uid}&createdby=${createdby}`).then(res => res)
    }

    GetDepotScan(d) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetTertiaryPackingScan?sid=${d}`).then(res => res)
    }

    // get all data
    // scan get tertiary packing 
    // GetTertiaryPackingScan(d,checkItemDate,soNumber,scanlist) {
    //     console.log('scanlist', scanlist);
    //     debugger
    //         return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetTertiaryPackingScan?sid=${d}&checkItemDate=${checkItemDate}&soNumber=${soNumber}`, scanlist).then(res => res)
    //     }
    // get all data
    // scan get tertiary packing 
    GetJourney(d) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetJourney?qr=` + d, null).then(res => res)
    }

    GetSecondary(d) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetSecondary?qr=` + d, null).then(res => res)
    }

    DeliveryDDL() {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetDeliveryDDL`).then(res => res);
    }

    GetMigoDDL() {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetMigoDDL`).then(res => res);
    }

    GetBatchDDL(selectedDeliveryId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetBatchFromDelDoc?DeliveryId=` + selectedDeliveryId).then(res => res);
    }

    GetMigoDetails(MigoNo) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetMigoDetails?MigoId=` + MigoNo).then(res => res);
    }

    GetTempDataForDispatch(selectedDeliveryId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetTempDataForDispatch?DeliveryId=` + selectedDeliveryId).then(res => res);
    }

    GetDeliveryStatus(DeliveryId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetDeliveryStatus?DeliveryId=` + DeliveryId).then(res => res);
    }

    GetStorageDDL(DeliveryDetailId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetBatchFromDelDoc?DeliveryId=` + DeliveryDetailId).then(res => res);
    }

    //SaveDispatchCartonintoTemp
    SaveDispatchCartonintoTemp(formData) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SaveDispatchCartonintoTemp`, formData).then(res => res)
    }
}